import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import FilterSidebar from './components/FilterSidebar';
import OrdersList from './components/OrdersList';

// Import react-bootstrap components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from 'react-bootstrap/Pagination';

const API_BASE_URL = 'https://littlehibba.com/api';

function ManageOrdersPage() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({ 'order_status': ['1'] });
    const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1 });
    const pageLimit = 50;

    const groupAndPrepareOrders = (orderList) => {
        if (!orderList || !Array.isArray(orderList)) return [];

        // KURAL LİSTESİ: Dinamik karakterli kitapları ve uzantılarını burada belirtin.
        const DYNAMIC_BOOK_CONFIG = [
            { name: "My Du'a For You",      extension: 'jpg' },
            { name: "Name Book",            extension: 'png' },
            { name: "Little Muslim Explorer", extension: 'png' }, 
            {name: "The Ramadan Detective",       extension: 'png' },
            { name: "Allah Made Me",         extension: 'png', customSlug: 'Allah_made_me' },
            { name: "Animal Adventure",        extension: 'png',   },
    
        ];

        const slugify = (text) => {
            if (!text) return '';
            return text.toLowerCase().replace(/'/g, '').replace(/\s+/g, '_');
        }

        const groups = {};
        orderList.forEach(order => {
            
            let finalImageUrl;

            const dynamicConfig = DYNAMIC_BOOK_CONFIG.find(config => 
                order.product_name.includes(config.name)
            );

            // GÜNCELLENDİ: Varsa özel 'customSlug' kullanılır, yoksa standart slug oluşturulur.
            const productNameSlug = dynamicConfig?.customSlug || slugify(order.product_name.replace(/ Non Personalised/g, ''));

            if (dynamicConfig && order.book_character && order.book_character.trim() !== '') {
                finalImageUrl = `https://littlehibba.com/inc/img/${productNameSlug}/${order.book_character}.${dynamicConfig.extension}`;
            } else {
                finalImageUrl = `https://littlehibba.com/inc/img/${productNameSlug}/character.png`;
            }
            
            order.image_urls = [finalImageUrl];
            const baseId = order.order_id.split('_')[0];
            if (!groups[baseId]) {
                groups[baseId] = { baseOrderId: baseId, orders: [] };
            }
            groups[baseId].orders.push(order);
        });

        return Object.values(groups).sort((a, b) => new Date(b.orders[0].order_date) - new Date(a.orders[0].order_date));
    };

    const fetchOrders = useCallback(async () => {
        setLoading(true);
        setError(null);
        
        const params = new URLSearchParams({
            action: 'getOrders',
            page: pagination.currentPage,
            limit: pageLimit,
            search: filters.search || '',
            products: filters.products || '',
            start_date: filters.start_date || '',
            end_date: filters.end_date || '',
        });
        
        if (filters.order_status) {
            filters.order_status.forEach(status => {
                params.append('order_status[]', status);
            });
        }

        try {
            const response = await axios.get(`${API_BASE_URL}/index.php?${params.toString()}`);
            const apiResult = response.data.data;

            if (response.data.success && apiResult && Array.isArray(apiResult.data)) {
                const groupedAndPreparedOrders = groupAndPrepareOrders(apiResult.data);
                setOrders(groupedAndPreparedOrders);
                
                setPagination(prev => ({
                    ...prev,
                    totalPages: apiResult.totalPages,
                }));
            } else {
                setOrders([]);
                if (!response.data.success) {
                    const errorMessage = response.data.message || response.data.error || "API'den geçersiz bir yanıt geldi.";
                    throw new Error(errorMessage);
                }
            }
        } catch (err) {
            setError(err.message || 'Siparişler getirilirken bir hata oluştu. Lütfen tekrar deneyin.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [filters, pagination.currentPage]);

    useEffect(() => { fetchOrders(); }, [fetchOrders]);

    const handleFilterChange = (newFilters) => { setPagination(p => ({ ...p, currentPage: 1 })); setFilters(newFilters); };
    const handlePageChange = (pageNumber) => { if (pageNumber > 0 && pageNumber <= pagination.totalPages) { setPagination(p => ({ ...p, currentPage: pageNumber })); }};

    const renderPaginationItems = () => {
        let items = [];
        for (let number = 1; number <= pagination.totalPages; number++) {
            items.push(
                <Pagination.Item key={number} active={number === pagination.currentPage} onClick={() => handlePageChange(number)}>
                    {number}
                </Pagination.Item>,
            );
        }
        return items;
    };

    return (
        <Container fluid className="mt-4">
            <Row>
                <Col md={4} lg={3}>
                    <FilterSidebar initialFilters={filters} onFilter={handleFilterChange} apiBaseUrl={API_BASE_URL} />
                </Col>
                <Col md={8} lg={9}>
                    <Card>
                        <Card.Header as="h4">Manage Orders</Card.Header>
                        <Card.Body>
                            {loading && (
                                <div className="text-center p-5">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </div>
                            )}
                            {error && <p className="text-danger">{error}</p>}
                            {!loading && !error && (
                                <>
                                    <OrdersList orders={orders} onRefresh={fetchOrders} apiBaseUrl={API_BASE_URL} />
                                    {pagination.totalPages > 1 && (
                                        <div className="d-flex justify-content-center mt-3">
                                            <Pagination>{renderPaginationItems()}</Pagination>
                                        </div>
                                    )}
                                </>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ManageOrdersPage;